module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h2', [_vm._v("掲載されている複数のイベントにお申込をされる方へ")]), _vm._v(" "), _c('p', [_vm._v("\n    こちらから申請を行って頂きますと、イベント管理システム「イベントクリエイト」で作成されたイベントの申込に利用できるメールアドレスを発行致します。\n  ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n    発行されたメールアドレスを使い、参加申込を行ってください。\n  ")]), _vm._v(" "), _c('h3', [_vm._v("利用制限")]), _vm._v(" "), _c('p', [_vm._v("ご利用にあたって下記の利用制限がございます。予めご了承下さい。")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.doRegister()
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-danger': _vm.errors.originalAddress.length > 0
    }
  }, [_c('label', [_vm._v("転送先のメールアドレス")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.originalAddress),
      expression: "originalAddress"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "your-name@example.jp",
      "required": ""
    },
    domProps: {
      "value": (_vm.originalAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.originalAddress = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.originalAddress), function(e) {
    return _c('p', {
      staticClass: "form-control-feedback"
    }, [(e === 'Should not be empty.') ? _c('span', [_vm._v("入力してください。")]) : (e === 'Should be an email.' || e === 'This domain has no MX record.') ? _c('span', [_vm._v("正しいメールアドレスではありません。入力に誤りが無いかご確認下さい。")]) : (e === 'This domain is not allowed.') ? _c('span', [_vm._v("転送メールアドレス自信を登録する事はできません。")]) : _c('span', [_vm._v(_vm._s(e))])])
  }), _vm._v(" "), _c('p', {
    staticClass: "form-text text-muted"
  }, [_vm._v("※こちらにはあなたのメールアドレスを入力してください。")])], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-danger': _vm.errors.desiredCount.length > 0
    }
  }, [_c('label', [_vm._v("発行するメールアドレスは何件必要ですか？")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.desiredCount),
      expression: "desiredCount"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.desiredCount = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("4")]), _vm._v(" "), _c('option', [_vm._v("5")])]), _vm._v(" "), _vm._l((_vm.errors.desiredCount), function(e) {
    return _c('p', {
      staticClass: "form-control-feedback"
    }, [_c('span', [_vm._v(_vm._s(e))])])
  })], 2), _vm._v(" "), (_vm.sending) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": ""
    }
  }, [_vm._v("お待ち下さい...")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("発行する")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n    申請されますと、申請件数分の\n    "), _c('code', [_vm._v("*********@fwd.evecre.com")]), _vm._v("\n    というメールアドレスが発行されます。"), _c('br'), _vm._v("\n    発行されたメールアドレス宛に送られたメールは、「あなたのメールアドレス」宛に自動的に転送されます。\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("発行されたメールアドレスの利用期限は、発行から6ヶ月です。期限を過ぎたメールアドレスに送信されるメールは転送されません")]), _vm._v(" "), _c('li', [_vm._v("宛先数（To、Cc、Bccの合計）が50を超えるメールは転送されません")]), _vm._v(" "), _c('li', [_vm._v("10MBバイト（ヘッダー・本文を含める）を超えるメールは転送されません")]), _vm._v(" "), _c('li', [_vm._v("発行されたメールアドレスは、イベントクリエイトで作成されたイベントへの申し込み用途外には利用されないようご注意ください")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2700bea3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Form.vue
// module id = 202
// module chunks = 1